import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// mui
import { ThemeProvider } from "@mui/material/styles";
import { GlobalStyles } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Theme from "./styles/theme/index.js";
import "./styles/globals.css";

// toastify
import ToastStyledContainer from "./components/ToastStyledContainer";

// react route
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

// redux
import { store } from "./store";

// translation
import "./translation/i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={Theme}>
        <CssBaseline />
        <ToastStyledContainer />
        <GlobalStyles styles={{}} />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
